<template>
  <div class="district-station-select">
    <div class="main-content">
      <div class="left-list">
        <div
          v-for="(item, index) in options"
          :class="['item', { active: item === currentOption }]"
          :key="index"
          @click="selectOption(item)"
        >
          {{ item }}
        </div>
      </div>
      <div class="right-list">
        <template v-if="currentOption === '区域'">
          <div
            v-for="item in [{name: '不限'}].concat(list)"
            :key="item.value"
            :class="['item', { active: item.name === activeDistrict.name }]"
            @click="onSelect(item)"
          >
            {{ item.name }}
          </div>
        </template>
        <template v-if="currentOption === '地铁'">
          <div
            v-for="(item, idx) in [{line: '不限'}].concat(lines)"
            :key="idx"
            :class="['item', { active: item.line === activeLine.line }]"
            @click="onSelectLine(item)"
          >
            {{ item.line }}
          </div>
        </template>
      </div>
    </div>
     <div class="action-bar">
      <div class="btn cancel-btn" @click="onReset">重置</div>
      <span class="separate"></span>
      <div class="btn ensure-btn" @click="onConfirm">确认</div>
    </div>
  </div>
</template>

<script>
import { buryingPoint } from '@/utils/buryingPoint'
export default {
  name: 'DistrictStationSelect',
  props: {
    type: {
      type: String,
      required: true,
      validator: v => ['district', 'station', 'all'].includes(v)
    },
    activityId: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      required: true
    },
    lines: {
      type: Array,
      required: true
    },
    selectedDistrict: {
      type: Object,
      default: () => ({ name: '不限' })
    },
    selectedLine: {
      type: Object,
      default: () => ({ line: '不限' })
    },
    currentType: {
      type: String,
      default: 'district'
    }
  },
  data () {
    return {
      options: [],
      activeDistrict: { name: '不限' },
      currentOption: '区域',
      activeLine: { line: '不限' }
    }
  },
  mounted () {
    this.activeDistrict = { ...this.selectedDistrict }
    this.activeLine = { ...this.selectedLine }
    this.options = {
      district: ['区域'],
      station: ['地铁'],
      all: ['区域', '地铁']
    }[this.type]
    this.currentOption = this.currentType === 'district' ? '区域' : '地铁'
  },
  methods: {
    onSelect (item) {
      this.savePoint({ action: 37, optionName: item.name })
      this.activeDistrict = item
    },
    onSelectLine (item) {
      this.savePoint({ action: 37, optionName: item.line })
      this.activeLine = item
    },
    selectOption (item) {
      this.savePoint({ action: 37, optionName: item })
      this.currentOption = item
    },
    onReset () {
      this.savePoint({ action: 38 })
      this.activeDistrict = { name: '不限' }
      this.activeLine = { line: '不限' }
      this.currentOption = '区域'
      this.$emit('reset')
    },
    update (event, data) {
      if (data.name === '不限' || data.line === '不限') {
        this.$emit('reset')
      } else {
        this.$emit(event, data)
      }
    },
    onConfirm () {
      this.savePoint({ action: 9 })
      this.currentOption === '区域'
        ? this.update('selectDistrict', this.activeDistrict)
        : this.update('selectLine', this.activeLine)
    },
    // 埋点
    savePoint (params = {}) {
      buryingPoint({ sourceTag: 2, activityId: this.activityId, itemType: 2, ...params })
    }
  }
}
</script>

<style lang="scss" scoped>
.district-station-select {
  width: 100%;
  background: #fff;
}
.main-content {
  height: 4.18rem;
  display: flex;
}
.left-list {
  width: 33.8%;
  overflow-y: auto;
  max-height: 100%;
}
.item {
  cursor: pointer;
  color: #666;
  height: 0.96rem;
  line-height: 0.96rem;
  text-align: center;
  font-size: 0.28rem;
  font-weight: 400;
  &.active {
    color: #CA1B22;
    background: #F7F7F7;
  }
}
.right-list {
  width: 66.2%;
  padding-left: 0.47rem;
  padding-right: 0.4rem;
  max-height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  background: #F7F7F7;

  .item {
    text-align: left;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
.action-bar {
  width: 100%;
  height: 1rem;
  border-top: 1px solid #eee;
  display: flex;
  align-items: center;
  .btn {
    flex: 1;
    text-align: center;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.32rem;
  }
  .cancel-btn {
    color: #666;
  }
  .ensure-btn {
    color: #ca1b22;
  }
  .separate {
    display: inline-block;
    background: #d8d8d8;
    width: 1px;
    height: 0.4rem;
    line-height: 1rem;
  }
}
</style>
